<script lang="ts" setup>
import {computed} from "vue";
import {type SynchroRequestField} from "@/domain/type/synchro.api.type.ts";
import {getConfigByType} from "@/application/typeConfig/typeConfig.factory.ts";
import type {SynchroType} from "@/domain/type/synchro.type.ts";

const props = defineProps<{
  value: string,
  label: string,
  synchroType: SynchroType,
  request: SynchroRequestField
}>()

const config = getConfigByType(props.synchroType)

const value = computed(() => {
  return config?.printField(props.value, props.label)
})
</script>

<template>
  <div
    v-html="value"
    class="bg-input pa-2"
    style="width:100%; height: 100%; min-height: 43px; border: 1px solid rgba(20,20,21,0.37); border-radius: 4px;"
  />
</template>

<style scoped>

</style>
